import * as React from 'react';

export const BasketSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
    >
      <path
        fill='#1E2538'
        d='M4.246 21.584c.086.302.362.51.676.51h14.156c.314 0 .59-.208.676-.51l2.667-9.334H1.579l2.667 9.334Zm10.974-3.121.704-4.22a.703.703 0 1 1 1.387.232l-.703 4.219a.703.703 0 0 1-1.388-.231Zm-3.923-4.104a.703.703 0 1 1 1.406 0v4.22a.703.703 0 0 1-1.406 0v-4.22Zm-3.983-.693a.703.703 0 0 1 .81.578l.702 4.219a.703.703 0 1 1-1.387.23l-.703-4.218a.703.703 0 0 1 .578-.81ZM23.297 8.031h-2.475l-5.414-6.767a.703.703 0 1 0-1.098.878l4.711 5.89H4.98l4.71-5.89a.703.703 0 0 0-1.097-.878L3.178 8.03H.703A.703.703 0 0 0 0 8.734v1.407c0 .388.315.703.703.703h22.594A.703.703 0 0 0 24 10.14V8.734a.703.703 0 0 0-.703-.703Z'
      />
    </svg>
  );
};
